define('presentation/settings/reports/presentationObjects/reportPresentationObject',['constants/scheduledReportDeliveryFrequencyConstants','i18next'],function() {
    return function(){
        const ScheduledReportDeliveryFrequencyConstants = require('constants/scheduledReportDeliveryFrequencyConstants');

        const _i18n = require('i18next');

        const self = this;

        self.scheduledReportId = null;
        self.subject = null;
        self.message = null;
        self.deliveryFrequency = ko.observable(null);
        self.graphDataPointsBy = ko.observable(null);
        self.deliveryFormat = ko.observable(null);
        self.sendToEmailAddresses = [];
        self.timeframe = null;
        self.involvingHostedNumbers = [];
        self.involvingUsers = [];
        self.involvingUserGroups = [];
        self.modifiedDateTime = null;
        self.createdDateTime = null;
        self.iconName = 'scheduledReport';
        self.editScheduledReportUrl = null;

        self.deliveryFrequencyText = ko.pureComputed(() => {
            switch (self.deliveryFrequency()) {
                case ScheduledReportDeliveryFrequencyConstants.Daily:
                    return _i18n.t('reports:daily');
                case ScheduledReportDeliveryFrequencyConstants.Weekly:
                    return _i18n.t('reports:weekly');
                case ScheduledReportDeliveryFrequencyConstants.Monthly:
                    return _i18n.t('reports:monthly');
                default:
                    return "";
            }
        });
    };
});

